import querySelector from './lib/querySelector.js';

import { createSelector } from 'reselect';

export const pathname = (state) => state.router.location.pathname;

export const query = querySelector();
export const tab = createSelector(query, (query) => query.tab);
export const eid = createSelector(query, (query) => query.eid);
export const tid = createSelector(query, (query) => query.tid);
export const etype = createSelector(query, (query) => query.etype);
export const uid = createSelector(query, (query) => query.uid);
export const contact = createSelector(query, (query) => query.contact);
export const contactDetailId = createSelector(query, (query) => query.contactDetailId);
export const type = createSelector(query, (query) => query.type);
export const filter = createSelector(query, (query) => query.filter);
export const folder = createSelector(query, (query) => query.folder);
export const lead = createSelector(query, (query) => query.lead);
export const template = createSelector(query, (query) => query.template);
export const modal = createSelector(query, (query) => query.modal);
export const view = createSelector(query, (query) => query.view);
export const todoId = createSelector(query, (query) => query.todoId);
export const noteId = createSelector(query, (query) => query.noteId);
export const replyTo = createSelector(query, (query) => query.replyTo);
export const pipelineStageId = createSelector(query, (query) => query.pipelineStageId);
export const pipelineLeadId = createSelector(query, (query) => query.pipelineLeadId);
export const creatingMessageId = createSelector(query, (query) => query.creatingMessageId);
export const creatingLead = createSelector(query, (query) => query.creatingLead);
export const statusId = createSelector(query, (query) => query.statusId);
export const creating = createSelector(query, (query) => query.creating);
export const notificationFolderId = createSelector(query, (query) => query.notificationFolderId);
export const integrationAction = createSelector(query, (query) => query.integrationAction);
export const burstActionId = createSelector(query, (query) => query.burstActionId);
export const actionPipelineLeadId = createSelector(query, (query) => query.actionPipelineLeadId);
